export default "__VITE_ASSET__BpUkkLnH__"